import { createToaster, Portal, Spinner, Stack, Toast, Toaster as ChakraToaster } from '@chakra-ui/react';
import { AppTheme } from '../../theming/valuobject/app-theme.ts';

//##################################################
//#          From the Chakra UI snippets!          #
//##################################################

// eslint-disable-next-line react-refresh/only-export-components
export const toaster = createToaster({
  pauseOnPageIdle: true,
});

/**
 * Represents a Toaster component that displays toast notifications using a portal.
 * This component utilizes ChakraToaster to handle toast rendering and supports different toast types, titles, descriptions, actions, and other customization options.
 * It includes structural elements like toast indicators, spinners for loading states, and close triggers for dismissing notifications.
 * The toast is always placed in the center of the screen to ensure it is seen by the users
 */
export const Toaster = () => {
  return (
    <Portal>
      <ChakraToaster
        toaster={toaster}
        insetInline={{ mdDown: '4' }}
        position="absolute"
        top={'50%'}
        transform="translateY(-50%)"
        zIndex="10"
        pointerEvents="none"
      >
        {(toast) => (
          <Toast.Root width={'lg'} maxWidth={'100%'}>
            {toast.type === 'loading' ? <Spinner size="sm" color="blue.solid" /> : <Toast.Indicator />}
            <Stack gap="1" flex="1" maxWidth="100%">
              {toast.title && <Toast.Title fontSize={AppTheme.Size.PX_80}>{toast.title}</Toast.Title>}
              {toast.description && (
                <Toast.Description fontSize={AppTheme.Size.PX_64}>{toast.description}</Toast.Description>
              )}
            </Stack>
            {toast.action && <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>}
            {toast.meta?.closable && <Toast.CloseTrigger />}
          </Toast.Root>
        )}
      </ChakraToaster>
    </Portal>
  );
};
